import { Action } from '@ngrx/store';

export enum ProductActionTypes {
    PRODUCT_EDIT = '[PRODUCT] ProductEdit',
    PRODUCT_EDITED = '[PRODUCT] ProductEdited',
    PRODUCT_ADD = '[PRODUCT] ProductAdd',
    PRODUCT_ADDED = '[PRODUCT] ProductAdded',
    PRODUCT_DELETE = '[PRODUCT] ProductDelete',
    PRODUCT_DELETED = '[PRODUCT] ProductDeleted',
    PRODUCT_GET_PAGE = '[PRODUCT] ProductGetPage',
    PRODUCT_PAGE_LOADED = '[PRODUCT] ProductPageLoaded',
    PRODUCT_GET_ALL = '[PRODUCT] ProductGetAll',
    PRODUCT_GET_TYPES = '[PRODUCT] ProductGetTypes',
    PRODUCT_TYPES_LOADED = '[PRODUCT] ProductTypesLoaded',
    PRODUCT_GET_VARIETIES = '[PRODUCT] ProductGetVarieties',
    PRODUCT_VARIETIES_LOADED = '[PRODUCT] ProductVarietiesLoaded',
    PRODUCT_ALL_LOADED = '[PRODUCT] ProductAllloaded'
}

export class ProductAdd implements Action {
    readonly type = ProductActionTypes.PRODUCT_ADD;
    constructor(public payload: any) {}
}

export class ProductEdit implements Action {
    readonly type = ProductActionTypes.PRODUCT_EDIT;
    constructor(public payload: any) {}
}

export class ProductGetPage implements Action {
    readonly type = ProductActionTypes.PRODUCT_GET_PAGE;
    constructor(public payload: any) {}
}

export class ProductPageLoaded implements Action {
    readonly type = ProductActionTypes.PRODUCT_PAGE_LOADED;
    constructor(public payload: any) {}
}

export class ProductAdded implements Action {
    readonly type = ProductActionTypes.PRODUCT_ADDED;
    constructor(public payload: any) {}
}

export class ProductEdited implements Action {
    readonly type = ProductActionTypes.PRODUCT_EDITED;
    constructor(public payload: any) {}
}

export class ProductDelete implements Action {
    readonly type = ProductActionTypes.PRODUCT_DELETE;
    constructor(public payload: any) {}
}

export class ProductDeleted implements Action {
    readonly type = ProductActionTypes.PRODUCT_DELETED;
    constructor(public payload: any) {}
}

export class ProductGetAll implements Action {
    readonly type = ProductActionTypes.PRODUCT_GET_ALL;
    constructor(public payload: any) {}
}

export class ProductGetTypes implements Action {
    readonly type = ProductActionTypes.PRODUCT_GET_TYPES;
    constructor(public payload: any) {}
}

export class ProductTypesLoaded implements Action {
    readonly type = ProductActionTypes.PRODUCT_TYPES_LOADED;
    constructor(public payload: any) {}
}

export class ProductGetVarieties implements Action {
    readonly type = ProductActionTypes.PRODUCT_GET_VARIETIES;
    constructor(public payload: any) {}
}

export class ProductVarietiesLoaded implements Action {
    readonly type = ProductActionTypes.PRODUCT_VARIETIES_LOADED;
    constructor(public payload: any) {}
}

export class ProductAllLoaded implements Action {
    readonly type = ProductActionTypes.PRODUCT_ALL_LOADED;
    constructor(public payload: any) {}
}

export type ProductActions =
                | ProductAdd
                | ProductEdit
                | ProductGetPage
                | ProductPageLoaded
                | ProductAdded
                | ProductDeleted
                | ProductDelete 
                | ProductEdited
                | ProductGetAll
                | ProductAllLoaded
                | ProductGetTypes
                | ProductTypesLoaded
                | ProductGetVarieties
                | ProductVarietiesLoaded;